import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faAngleLeft,
  faExclamationTriangle
} from '@fortawesome/free-solid-svg-icons'
/*
 * React Font Awesome requires that we add each individual icon
 * to a "library" so that only the icons we use are included in
 * the final bundle.
 *
 * https://github.com/FortAwesome/react-fontawesome
 * https://github.com/FortAwesome/react-fontawesome#build-a-library-to-reference-icons-throughout-your-app-more-conveniently
 */

library.add(faAngleLeft, faExclamationTriangle)
